import React, { useContext } from 'react';
export var ButtonGroupContext = React.createContext({
    inButtonGroup: false,
});
export var useButtonGroupContext = function () {
    return useContext(ButtonGroupContext);
};
//# sourceMappingURL=Context.js.map